import { Avatar as AvatarAD } from 'antd';
import { type ComponentProps, type ReactNode, useCallback, useEffect, useState } from 'react';
import { images } from 'common/utils';
import type { UploadedFile } from '../../models/uploaded-file';
import { Badge } from '../badge';

export type AvatarProperties = {
  badge?: { icon?: ReactNode };
  fallbackPhoto?: string;
  photo?: string | UploadedFile;
} & ComponentProps<typeof AvatarAD>;

const getInitials = (name: string[]) =>
  name
    .slice(0, name.length + 1)
    .map((string_) => string_[0])
    .join('');

const Avatar = ({ badge, children, fallbackPhoto, icon, photo, ...rest }: AvatarProperties) => {
  // TODO make proper default with correct planned task
  const content = typeof children === 'string' ? getInitials(children.split(' ')) : children;
  const source = icon ?? (typeof photo === 'object' ? photo.url : photo) ?? images.default.userProfilePhoto;

  const [avatarSource, setAvatarSource] = useState(source);
  const handleError = useCallback(() => {
    setAvatarSource(fallbackPhoto ?? images.default.userProfilePhoto);
    return false;
  }, [fallbackPhoto]);

  useEffect(() => {
    setAvatarSource(source);
  }, [source]);

  if (badge) {
    return (
      <Badge count={badge.icon} display="flex" offset={[-5, 27]}>
        <AvatarAD icon={icon} onError={handleError} src={avatarSource} {...rest}>
          {content}
        </AvatarAD>
      </Badge>
    );
  }

  return (
    <AvatarAD icon={icon} onError={handleError} src={avatarSource} {...rest}>
      {content}
    </AvatarAD>
  );
};

export default Avatar;
